import React from 'react'
import Text from '../../../core/components/typography/text/Text'
import {UniLink} from '../../../core/components/unilink/index'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import './relatedLessons.css'

/**
 * RelatedLessons - This component refers to the first items on any leaf topic
 * page, above the explanations. We show up to four related topics, from the
 * flat map (topological sorting of all topics) generated by server. If any of
 * the related topics are not from the same subject (e.g., Algebra 1) as the
 * current topic, we discard them and only display the rest.
 */
class RelatedLessons extends React.PureComponent {
  render() {
    const {colorSubject, breadcrumbTopics, nextLeaf, prevLeaf, nearLeaf1, nearLeaf2} = this.props
    const subjectID = breadcrumbTopics[0].id
    const parentSlug = breadcrumbTopics[breadcrumbTopics.length-1].slug
    // const parentTitle = breadcrumbTopics[breadcrumbTopics.length-1].renderedTitle

    const leaf1 = 
      prevLeaf && prevLeaf.breadcrumbs[0].id === subjectID &&
        <div 
          className='related-lesson-bar__related-lesson-box'
          key={1}
        >
          <UniLink to={{
            pathname: prevLeaf.slug,
            state: {leafDirection: 'left'}
          }}>
             
              <Text
                size='sm'
                overflow='normal'
                color={`${colorSubject}-cta`}
                fontWeight='medium'
                dangerouslySetInnerHTML={{__html:prevLeaf.renderedTitle}} />
          </UniLink>  
        </div>
    
    const leaf2 =
      nextLeaf && nextLeaf.breadcrumbs[0].id === subjectID &&
        <div 
          className='related-lesson-bar__related-lesson-box'
          key={2}
        >
          <UniLink to={{
            pathname: nextLeaf.slug,
            state: {leafDirection: 'left'}
          }}>
             
              <Text
                size='sm'
                overflow='normal'
                color={`${colorSubject}-cta`}
                fontWeight='medium'
                dangerouslySetInnerHTML={{__html:nextLeaf.renderedTitle}} />
          </UniLink>  
        </div>

    const leaf3 =
      nearLeaf2 && nearLeaf2.breadcrumbs[0].id === subjectID &&
        <div 
          className='related-lesson-bar__related-lesson-box'
          key={3}
        >
          <UniLink to={{
            pathname: nearLeaf2.slug,
            state: {leafDirection: 'left'}
          }}>
              <Text
                size='sm'
                overflow='normal'
                color={`${colorSubject}-cta`}
                fontWeight='medium'
                dangerouslySetInnerHTML={{__html:nearLeaf2.renderedTitle}} />
          </UniLink>  
        </div>

    const leaf4 = 
    nearLeaf1 && nearLeaf1.breadcrumbs[0].id === subjectID &&
      <div 
        className='related-lesson-bar__related-lesson-box'
        key={4}
      >
        <UniLink to={{
          pathname: nearLeaf1.slug,
          state: {leafDirection: 'left'}
        }}>
            <Text
              size='sm'
              overflow='normal'
              color={`${colorSubject}-cta`}
              fontWeight='medium'
              dangerouslySetInnerHTML={{__html:nearLeaf1.renderedTitle}} />
        </UniLink>  
      </div>

    const leaves = [leaf1, leaf2, leaf3, leaf4]

    const visibleLeaves = leaves.filter(leaf => leaf)

    // Instead of having to deal with css, we have this HACK solution where
    // the unrelated leaves are instead just invisible leaves, thrown at the
    // end.
    const invisibleLeaves = leaves.filter(leaf => !leaf).map((leaf,index) =>
      <div className='related-lesson-bar__related-lesson-box'
        style={{visibility:'hidden'}}
        key={index} />
    )

    const viewAllLesson = 
      <div className='related-lesson-bar__related-lesson-box'>
        <UniLink to={parentSlug}>
            <Text
              size='sm'
              overflow='normal'
              color={`${colorSubject}-cta`}
              fontWeight='medium'
              dangerouslySetInnerHTML={{__html:'View All Related Lessons'}} />
        </UniLink>
      </div>

    // A maximum of only one loading spinner exists at any time
    const loadingSpinner = !(prevLeaf && nextLeaf && nearLeaf1 && nearLeaf2) &&
      <div className='related-lessons-bar__loading-box'>
        <LoadingSpinner noMargin />
      </div>

    return (
      <div>
        <div className='related-lessons-bar__lessons-container'>
          <div className='related-lessons-bar__spacer'> &nbsp;</div>
          { visibleLeaves }
          { loadingSpinner }
          { viewAllLesson }
          { invisibleLeaves }
          <div className='related-lessons-bar__spacer'> &nbsp;</div>
        </div>
      </div>
    )
  }
}

export default RelatedLessons



// WEBPACK FOOTER //
// ./src/domains/topic/components/RelatedLessons.js